/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { Job } from '../../services/playlist';
import { GlobalState } from '../actions';
import { JobServerState } from './reducer';

export const jobManagementStateSelector = (state: GlobalState) => state.jobManagement;

export const serverJobManagementSelector = (state: GlobalState, serverName: string): JobServerState => {
    const r = jobManagementStateSelector(state)[serverName];
    return r;
};

export const scheduledJobsSelector = (state: GlobalState, serverName: string): Job[] | null  => {
    const r = serverJobManagementSelector(state, serverName);
    return r ? r.jobs : null;
};

export const availableJobsSelector = (state: GlobalState, serverName: string): string[] | null => {
    const r = serverJobManagementSelector(state, serverName);
    return r ? r.availableJobNames : null;
};

export const jobSchedulerStateSelector = (state: GlobalState, serverName: string): boolean | null  => {
    const r = serverJobManagementSelector(state, serverName);
    return r ? r.enabled : null;
};

export const showJobCreateFormSelector = (state: GlobalState, serverName: string): boolean | null  => {
    const r = serverJobManagementSelector(state, serverName);
    return r ? r.showCreateJobForm : null;
};

export const jobManagementServerAvailableSelector = (state: GlobalState, serverName: string): boolean | null  => {
    const r = serverJobManagementSelector(state, serverName);
    return r ? r.serverAvailable : null;
};
